import { render, staticRenderFns } from "./BasicInfoForm.vue?vue&type=template&id=7185bac6&scoped=true&"
import script from "./BasicInfoForm.vue?vue&type=script&lang=js&"
export * from "./BasicInfoForm.vue?vue&type=script&lang=js&"
import style0 from "./BasicInfoForm.vue?vue&type=style&index=0&id=7185bac6&scoped=true&lang=css&"
import style1 from "./BasicInfoForm.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7185bac6",
  null
  
)

export default component.exports